import React from 'react';
import {Input} from 'reactstrap';
import arrow from './images/arrow.svg';

const SelectInput = (props) => {
  let inputClass = 'select-box';
  let errorMsg = '';

  if (props.error && props.error.length > 0) {
    inputClass = 'select-error';
    errorMsg = props.error;
  }

  () => this.props.openPopUp();
  return (
    <div className='select-input'>
      <label className={`has-float-${props.required ? 'label-required' : 'label'}`}>
        <Input
          type='select'
          className={inputClass}
          name={props.name}
          id={props.id}
          onChange={props.onChange}
          // placeholder={props.value || props.placeholder}
          disabled={props.disabled}>
          {/* <option selected style={{color: '#747374'}} value={props.value || ''}>
            {props.value || props.defaultText || null}
          </option> */}
          <option value='' hidden>
            {props.placeholder || 'בחר'}
          </option>
          {props.options.map((item) => {
            return item.name === props.value ? (
              <option selected style={{color: '#747374'}} value={props.value || ''}>
                {props.value || props.defaultText || null}
              </option>
            ) : (
              <option key={item[props.dataKey]} value={item[props.dataKey]}>
                {item[props.dataValue]}
              </option>
            );
          })}
        </Input>
        <span>{props.placeholder}</span>
        {props.error && props.error.length > 0}
        <div className='error'>{props.error}</div>
      </label>
    </div>
  );
};

export default SelectInput;
